import React, { useState, useEffect } from "react";

import { useList } from "store/list";
import { useCore } from "store/core";
import { Formik, Field, Form } from "formik";
import {
  TextField,
  Loading,
  MultiSelect,
  Select,
  PersianDataPicker,
} from "components/form";
import {
  generate_uuid,
  dateTimeToserver,
  transformTranslateFromValues,
  transformTranslateServerValues,
} from "lib/helpers";
import { required, validationWrapper, number } from "lib/formValidations";
export default function ListFilter(props) {
  const core = useCore();
  const [loadReport, setLoadReport] = useState(false);
  const {
    dispatch,
    clear,
    getList,
    list,
    load,
    createAndDownload,
    remove,
    listSearch,
    from,
    to,
    listFilter,
    total,
    filters,
    dowloadEexelReport,
  } = useList();

  return (
    <div className="intro-y p-2 bg-white grid col-span-12 flex flex-wrap sm:flex-nowrap items-center mt-2 selector-dark">
      <h3 className="intro-y text-sm font-medium col-span-12 my-2">فیلترها</h3>
      <Formik
        initialValues={filters}
        onSubmit={async (values, { setSubmitting }) => {
          if (values.date_from)
            values.date_from = dateTimeToserver(values.date_from, "YYYY-MM-DD");
          if (values.date_to)
            values.date_to = dateTimeToserver(values.date_to, "YYYY-MM-DD");
          await dispatch(listFilter(props.path, values));
          setSubmitting(false);
        }}
        enableReinitialize
      >
        {({ isSubmitting, dirty, values, setFieldValue }) => (
          <Form className="grid grid-cols-12 gap-x-2 col-span-12">
            <>
              {" "}
              {props.items &&
                props.items.length > 0 &&
                props.items.map((item) => {
                  switch (item.type) {
                    case "SELECT":
                      return (
                        <Field
                          placeholder={item.label}
                          label={item.label + ":"}
                          name={item.name}
                          component={Select}
                          options={item.options}
                        />
                      );
                    case "DATE_FROM_TO":
                      return (
                        <div className="col-span-5 flex justify-center gap-x-1 items-end">
                          <div className="w-56 relative text-gray-700 dark:text-gray-300 ">
                            <Field
                              placeholder="از تاریخ"
                              label="از تاریخ :"
                              name="date_from"
                              component={PersianDataPicker}
                              disable_today={true}
                            />
                          </div>
                          <button
                            type="button"
                            onClick={() => {
                              setFieldValue("date_to", null);
                              setFieldValue("date_from", null);
                            }}
                          >
                            <svg
                              height="20"
                              width="20"
                              viewBox="0 0 20 20"
                              aria-hidden="true"
                              focusable="false"
                              class="css-tj5bde-Svg"
                            >
                              <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
                            </svg>
                          </button>
                          <div className="w-56 relative text-gray-700 dark:text-gray-300">
                            <Field
                              placeholder="تا تاریخ"
                              label="تا تاریخ :"
                              name="date_to"
                              component={PersianDataPicker}
                              disable_today={true}
                            />
                          </div>
                        </div>
                      );
                    case "TEXT":
                      return (
                        <div className="col-span-3">
                          <Field
                            placeholder={item.label}
                            label={item.label + ":"}
                            name={item.name}
                            component={TextField}
                          />
                        </div>
                      );
                    case "PRICE_FROM_TO":
                      return (
                        <div className="col-span-5 flex justify-center items-end">
                          <Field
                            placeholder="مبلغ از"
                            label={"مبلغ از:"}
                            name="price_from"
                            component={TextField}
                            type="number"
                            validate={(value) =>
                              validationWrapper(value, number)
                            }
                          />
                          <button
                            type="button"
                            onClick={() => {
                              setFieldValue("price_to", "");
                              setFieldValue("price_from", "");
                            }}
                          >
                            <svg
                              height="20"
                              width="20"
                              viewBox="0 0 20 20"
                              aria-hidden="true"
                              focusable="false"
                              class="css-tj5bde-Svg"
                            >
                              <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
                            </svg>
                          </button>
                          <Field
                            placeholder="مبلغ تا"
                            label={"مبلغ تا:"}
                            name="price_to"
                            component={TextField}
                            type="number"
                            validate={(value) =>
                              validationWrapper(value, number)
                            }
                          />
                        </div>
                      );
                  }
                })}
              <div className="col-span-12 flex justify-end gap-x-3 mt-3">
                <button
                  className="btn btn-primary w-36"
                  type="submit"
                  disabled={!!(isSubmitting || !dirty)}
                >
                  {" "}
                  {isSubmitting ? <Loading /> : "اعمال"}
                </button>
                {props.hasExcelReport && (
                  <button
                    className="btn btn-primary w-36"
                    type="button"
                    disabled={loadReport}
                    onClick={async () => {
                      setLoadReport(true);
                      let values_t = values;
                      if (values.date_from)
                        values_t.date_from = dateTimeToserver(
                          values.date_from,
                          "YYYY-MM-DD"
                        );
                      if (values.date_to)
                        values_t.date_to = dateTimeToserver(
                          values.date_to,
                          "YYYY-MM-DD"
                        );
                      await dispatch(dowloadEexelReport(props.path, values_t));
                      setLoadReport(false);
                    }}
                  >
                    {" "}
                    {isSubmitting ? <Loading /> : "دریافت اکسل"}
                  </button>
                )}
              </div>
            </>
          </Form>
        )}
      </Formik>
    </div>
  );
}
